module.exports = "<button *ngIf=\"!disabled\" md-button class=\"wg-icon\" mdTooltip=\"{{ 'ADD_TO_CART' | tooltip }}\" color='primary' (click)=\"onAddToCart($event)\">\n  <i class=\"material-icons icon add-to-cart\"></i>\n</button>\n\n<button *ngIf=\"disabled\" md-button class=\"wg-icon\"  mdTooltip=\"{{ 'NOT_DOWNLOADABLE' | tooltip }}\" color='primary' style=\"cursor: not-allowed\">\n  <i class=\"material-icons icon disabled\">shopping_cart</i>\n</button>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/add-to-cart/add-to-cart.component.html
// module id = ./src/app/shared/add-to-cart/add-to-cart.component.html
// module chunks = main